module.exports = __webpack_public_path__ + "img/luxury-green.4f8ff64d.png";